import { render, staticRenderFns } from "./AppDropDownListOwnerType.vue?vue&type=template&id=0bf0bdea"
import script from "./AppDropDownListOwnerType.vue?vue&type=script&lang=ts"
export * from "./AppDropDownListOwnerType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports